(ns machtfit.repository.core
  (:require
   [re-frame.core :as rf]))

(def db-path-base
  [:repository])

(defn async-query-data [path load-fn & {:keys [expectation-fn]}]
  (let [data @(rf/subscribe [:get path])]
    (if (and data
             (or (not expectation-fn)
                 (expectation-fn data)))
      data
      (do
        (load-fn)
        {:status :loading}))))
